import * as all_advertisements from "components/adbutler-advertisements"
import * as all_content_components from "../content-components"
import * as all_link_modules from "../link-modules"
import * as all_native_advertisements from "components/native-advertisements"
import * as signup_modules from "components/page-components/Signup-Modules"

export const all_article_components = {
  box: all_content_components.InfoBox,
  facebook_post: all_content_components.FacebookPost,
  heading_2: all_content_components.HeadingTwo,
  heading_3: all_content_components.HeadingThree,
  image: all_content_components.Image,
  image_title: all_content_components.ImageTitle,
  image_zoomable: all_content_components.ImageZoomable,
  list: all_content_components.List,
  paragraph: all_content_components.Paragraph,
  question: all_content_components.Paragraph,
  quote: all_content_components.Quote,
  table: all_content_components.Table,
  tweet: all_content_components.Tweet,
  video_youtube: all_content_components.VideoYoutube,
  // -- ads
  advertorial_2: all_native_advertisements.AdvertorialTwo,
  advertorial_3: all_native_advertisements.AdvertorialThree,
  billboard_content: all_advertisements.BillboardContent,
  rectangle: all_advertisements.Rectangle,
  // horizontal: all_advertisements.Horizontal,
  leaderboard_content: all_advertisements.LeaderboardContent,
  outstream_video: all_advertisements.VideoAd,
  // -- link modules
  newsletter_signup: signup_modules.NewsletterSignupBoxed,
  article_demo_tender: all_link_modules.ArticleDemoTender,
  construction_methods: all_link_modules.ConstructionMethodsHorizontal,
  notice_wizard: all_link_modules.ArticleNoticeWizard,
  related_articles: all_link_modules.RelatedArticlesHorizontal,
  most_read_articles: all_link_modules.MostReadArticlesHorizontal,
}
